import $ from '../core/Dom';
import Dispatch from '../core/Dispatch';
import * as eventKeys from '../lib/events';

export default el => {

    const $el = $(el);
    const src = $el.data('src');
    const $video = $el.find('video');
    const video = $video.get(0);

    if (!src || !video) {
        return null;
    }

    const hideVideo = () => {
        $video.css({ opacity: 0 });
    };

    const playAnimation = () => {
        const promise = video.play();
        if (!promise) {
            return;
        }
        promise
            .then(() => {
                $video.css({ opacity: 1 });
            })
            .catch(() => {
                $video.css({ opacity: 0 });
            });
    };

    const onMenuOpen = () => {
        hideVideo();
    };

    const onHeaderBeforeHide = () => {
        hideVideo();
    };

    const onHeaderBeforeShow = () => {
        playAnimation();
    };

    const onInformationPanelVisible = () => {
        hideVideo();
    };

    const onVideoEnd = () => {
        hideVideo();
    };

    const init = () => {
        if (!video.canPlayType || !video.canPlayType('video/mp4')) {
            return;
        }
        Dispatch.on(eventKeys.LOCK_MENU_BAR, onMenuOpen, true);
        Dispatch.on(eventKeys.HEADER_BEFORE_HIDE, onHeaderBeforeHide, true);
        Dispatch.on(eventKeys.HEADER_BEFORE_SHOW, onHeaderBeforeShow, true);
        Dispatch.on(eventKeys.INFORMATION_PANEL_VISIBLE, onInformationPanelVisible, true);
        video.src = src;
        video.onended = onVideoEnd;
    };

    const destroy = () => {
        Dispatch.off(eventKeys.LOCK_MENU_BAR, onMenuOpen);
        Dispatch.off(eventKeys.HEADER_BEFORE_HIDE, onHeaderBeforeHide);
        Dispatch.off(eventKeys.HEADER_BEFORE_SHOW, onHeaderBeforeShow);
        Dispatch.off(eventKeys.INFORMATION_PANEL_VISIBLE, onInformationPanelVisible);
    };

    return {
        init,
        destroy
    };

};
